import { configureStore } from '@reduxjs/toolkit';

import rootReducer from 'store/reducers/index';
import { apiSlice } from './api/apiSlice';

const store = configureStore({
  devTools: true,
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => [...getDefaultMiddleware(), apiSlice.middleware],
});

export type StoreState = ReturnType<typeof store.getState>;
export type StoreDispatch = typeof store.dispatch;

export default store;
